export const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6] }, { font: [] }],
    [{ size: [] }],
    [`bold`, `italic`, `underline`, `strike`, `blockquote`],
    [{ list: `ordered` }, { list: `bullet` }],
    [{ align: [] }],
    [`link`],
    [`clean`],
    [`code-block`],
  ],
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

export const mobileModules = {
  toolbar: [
    [`bold`, `italic`, `underline`, `strike`, `blockquote`],
    [{ list: `ordered` }, { list: `bullet` }],
    [{ align: [] }],
    [`link`],
    [`clean`],
    [`code-block`],
  ],
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

export const formats = [
  `header`,
  `font`,
  `size`,
  `bold`,
  `italic`,
  `underline`,
  `strike`,
  `blockquote`,
  `list`,
  `bullet`,
  `link`,
  `code-block`,
  `align`,
];
